import React, { Component } from 'react';
import PropTypes from 'prop-types';

class StepFooter extends Component {

  validate () {
    return this.props.isLoading;
  }

  render () {
    let errorMessage = this.props.errorMessage;
    return (
      <span>
        <button onClick={this.props.handleNextClick}
          className={'registration__next button button--shadow button--l ' + (this.props.isLoading ? 'is-loading' : '')}
          disabled={this.validate()}>
          Next
        </button>
        <a style={{position: 'relative', top: '18px', left: '20px'}} onClick={this.props.handlePreviousClick} className='registration__previous registration__exit'>Previous step</a>
        {errorMessage &&
          <span className='error-message error-message--standalone'>{errorMessage}</span>
        }
        <p className='cta-info'>Not sure? <a className='cta-info__standout' href='/contact'>Ask an expert for help</a> or <a href='/courses'>view all courses</a></p>
      </span>
    );
  }
}

StepFooter.propTypes = {
  handlePreviousClick: PropTypes.func.isRequired,
  handleNextClick: PropTypes.func.isRequired,
  errorMessage: PropTypes.string,
  isLoading: PropTypes.bool
};

export default StepFooter;



// WEBPACK FOOTER //
// ./src/components/CoursePicker/StepFooter/index.js